import React,{Component} from 'react';
import{Route,Link,Switch} from 'react-router-dom'
import firebase from '../config'
import {Box,Button} from '@material-ui/core'
import { Popconfirm} from 'antd';

export default class Query extends Component{
    constructor(){
        super()
        this.state={
            data :[]
        }
    }
    componentDidMount(){
        var temp = []
        firebase.firestore().collection('queries').get().then(snap =>{
            snap.forEach(doc => {
                var obj =doc.data()
                obj.id = doc.id;
                temp.push(obj);
                console.log(obj)
                setTimeout(()=>{
                    this.setState({
                        data : temp
                    })
                },1000)

            })
            
        })
    }
    confirm(id){
        firebase.firestore().collection('queries').doc(id).delete().then(()=>{
            alert('deleted')
        })
    }
    display = (props) =>{
        var data = props.data;
        console.log(props)
        return <Box border="1px solid black" padding="5px" margin="5px 0"  display="flex" flexDirection="row" justifyContent="space-between">
            <Box>
                {data.name} 
            </Box>
            <Box>
                {data.test}
            </Box>
            <Box>
                {data.phone}
            </Box>
            <Box>
            <Popconfirm
                                    title="Are you sure delete this task?"
                                    onConfirm={()=>this.confirm(data.id)}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                     <Button variant="contained" color="primary">Delete</Button>
                                </Popconfirm>            </Box>

        </Box>
    }

    render(){
       let data = this.state.data
        if(data.length > 0) return(
            <div>
                        <Box border="1px" padding="5px" margin="5px 0" display="flex" flexDirection="row" justifyContent="space-between">

                            <Box fontWeight="bold" fontSize="1.2em">
                                Name
                            </Box>
                            <Box fontWeight="bold" fontSize="1.2em">
                                Test 
                            </Box>
                            <Box fontWeight="bold" fontSize="1.2em">
                                Phone
                            </Box>
                            <Box fontWeight="bold" fontSize="1.2em">
                                Action
                            </Box>

                            </Box>


                            {
                                
                                data.map(e =>{
                                    return <this.display data={e}/>
                                })
                            }

            </div>



        

        

        )
        else 
            return <h2>No Queries</h2>
    }
}

